import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { TabbedRepositorySelector } from "../components/TabbedRepositorySelector";

export default function InfraRepoDialog(props: {
  projectName : string;
  open: boolean;
  onCancel: () => any;
  onSave: (repoName: string) => any;
}) {

  const [selectedRepoInfo, setSelectedRepoInfo] = useState({} as {name : string, type : string});

  return (
    <Dialog open={props.open}>
      <DialogTitle>Infrastructure repository</DialogTitle>
      <DialogContent>
          <TabbedRepositorySelector 
            selectedRepoInfo={selectedRepoInfo} 
            projectName={props.projectName}
            onChange={setSelectedRepoInfo}
          />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={selectedRepoInfo.name === ""}
          onClick={() => props.onSave(selectedRepoInfo.name)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
